import React from 'react';
import withTranslation from '../../hoc/withTranslation';
import { red200, red800 } from 'material-ui/styles/colors';

const sectionStyle = {
    height: 'auto',
    backgroundColor: red200,
    color: '#000',
    border: `2px solid ${red800}`,
    margin: '100px 0 10px',
    padding: '15px',
    display: 'block',
    position: 'relative',
}
const textStyle = {
    margin: 0,
    padding: 0,
}
class ImportIndicator extends React.Component {
    render() {
        return (
            <section style={sectionStyle}>
                <p style={textStyle}>
                    {this.props.t('generic.import_warning')}
                </p>
            </section>
        );
    }
}

export default withTranslation(ImportIndicator);



// WEBPACK FOOTER //
// src/components/import/ImportIndicator.js